'use client'

import { useState } from 'react'
import s from './ExpandableCards.module.scss'
import { MagnifierIcon } from '@/components/icon/icons'
import Image from 'next/image'

interface ExpandableCardsProps {
  items: Array<{
    title: string
    text: string
  }>
  onActiveChange?: (index: number) => void
  defaultActiveIndex?: number
  className?: string
  imageType?: 'phone' | 'laptop' | 'none' // Typ obrazków: phone dla homepage, laptop dla /dla-osk, none dla bez obrazków
}

export function ExpandableCards({
  items,
  onActiveChange,
  defaultActiveIndex = 0,
  className = '',
  imageType = 'phone',
}: ExpandableCardsProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(
    defaultActiveIndex
  )

  const handleToggle = (index: number) => {
    setActiveIndex(index)
    onActiveChange?.(index)
  }

  // Mapowanie obrazków dla każdego kafelka
  const getImageForIndex = (index: number) => {
    if (imageType === 'laptop') {
      // Obrazki screenów laptopa dla strony /dla-osk
      return `/photos/screen${index + 1}-notebook.webp`
    } else if (imageType === 'none') {
      // Bez obrazków
      return null
    } else {
      // Obrazki telefonu dla homepage - screen1, screen2, screen3, screen4
      return `/photos/screen${index + 1}.webp`
    }
  }

  return (
    <div className={`${s.features} ${className}`}>
      {items.map((item, index) => (
        <div
          key={index}
          className={s.feature}
          data-active={index === activeIndex}
          onClick={() => handleToggle(index)}
        >
          <div
            className={`${s.icon} ${index === activeIndex ? s.iconActive : ''}`}
          >
            <MagnifierIcon width={20} height={20} />
          </div>
          <div className={s.content}>
            <div className={s.featureTitle}>{item.title}</div>
            <p
              className={`${s.featureText} ${
                index === activeIndex ? s.expanded : s.collapsed
              }`}
            >
              {item.text}
            </p>
            {/* Obrazek pojawia się tylko w rozwiniętym kafelku na mobile */}
            {index === activeIndex && getImageForIndex(index) && (
              <div className={s.imageContainer}>
                <Image
                  src={getImageForIndex(index)!}
                  alt={item.title}
                  width={800}
                  height={470}
                  quality={95}
                  className={s.featureImage}
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
